// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
// ##### 24-08-01 Komarov
import uniqueId from 'lodash.uniqueid';
// ##### 25-04-23 Komarov
import { useDispatch, useSelector } from 'react-redux';
import { selectDeviceType } from '../../../../Redux/selectors';
import { useHistory } from 'react-router-dom';
// ##### 24-12-26 Komarov
import { makeParamsString } from '../../Helpers/helper';
// ##### 25-05-21 Komarov
import BodyPageImg from './BodyPageImg';
// ##### 25-04-23 Komarov
import { getLoadedPage } from '../../../../Redux/actions';
// ##### Komarov 2025-08-21
import { usePerformanceMeasure } from '../../../../hooks/usePerformanceMeasure';

// ##### Komarov 2025-07-14
// import '../../PageComponents/ResponsiveHeader/header.css'
// import './TopToursCSS.css'

// ##### Komarov 2025-07-24
const BodyPage = ({ sidePageID = 210, sitePageName = 'warukrainespec' }) => {
  // ##### Komarov 2025-08-27
  const componentDevMode = useSelector(state => state.devMode);
  // ##### Komarov 2025-08-27
  // Use the performance measurement hook
  usePerformanceMeasure('BodyPage', {
    logToConsole: true,
    componentDevMode,
    onMeasure: (result) => {
      // You can add additional analytics or logging here
      console.log(`📊 Performance data for BodyPage (${result.environment}):`, result);

      // Example: Send to analytics
      // analytics.track('component_performance', {
      //   ...result,
      //   page: typeof window !== 'undefined' ? window.location.pathname : 'server'
      // });
    }
  });
  // ##### Komarov 2025-07-28
  const loadedpages = useSelector(state => state.pages.loadedpages);
  const language = useSelector(state => state.language);
  const dispatch = useDispatch();
  const article = loadedpages[sidePageID];
  const deviceType = useSelector(selectDeviceType);

  // ##### Komarov 2025-07-24
  useEffect(() => {
    if (!article) {
      dispatch(
        getLoadedPage({
          spid: sidePageID,
          lang: language,
          deviceType,
        })
      );
    }
    // ##### Komarov 2025-07-28
  }, [sidePageID, language, deviceType]);

  const history = useHistory();

  const GetBannerDetails = () => {
    // ##### 24-12-26 Komarov
    const params_string = makeParamsString({
      name: sitePageName.replace(/\s/g, '-').toLowerCase(),
      // ##### 25-04-21 Komarov
      spid: sidePageID,
    });
    // ##### 25-03-26 Komarov
    const route_query = `/${language}/sitepages/?${params_string}`;
    history.push(route_query);
  };

  return (
    <div
      data-component="BodyPage"
      className="frontPageArticle"
      style={{ order: '3' }}
    >
      {article?.Image
        ?
        <div
          // ##### 23-11-07 Komarov
          key={uniqueId()}
          onClick={GetBannerDetails}
          // ##### 24-03-21 Komarov
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              GetBannerDetails();
            }
          }}
          className="frontPageBanner"
        >
          { /* ##### Komarov 2025-07-28 */}
          <BodyPageImg item={article.Image} style={{ width: '100%' }} />
        </div>
        : null}
    </div>
  );
};

export default BodyPage;
